import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=065a3468&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=065a3468&prod&lang=css&"
import style1 from "./Sidebar.scss?vue&type=style&index=1&id=065a3468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a3468",
  null
  
)

export default component.exports